document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.innerWidth < 750;
  }

  function syncResponsiveAccordions() {
    document.querySelectorAll('.luneorae-footer__accordion, .product-page__accordion').forEach(function (el) {
      if (isMobile()) return;
      el.setAttribute('open', '');
    });
  }

  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileOpen = document.querySelector('[data-mobile-menu-open]');
  if (mobileNav && mobileOpen) {
    function closeMobileNav() {
      mobileNav.hidden = true;
      mobileOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-nav-open');
    }
    function openMobileNav() {
      mobileNav.hidden = false;
      mobileOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mobile-nav-open');
      var closeBtn = mobileNav.querySelector('[data-mobile-menu-close]');
      if (closeBtn) closeBtn.focus();
    }
    mobileOpen.addEventListener('click', openMobileNav);
    mobileNav.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMobileNav);
    });
    mobileNav.querySelectorAll('.luneorae-mobile-nav__links a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mobileNav.hidden) closeMobileNav();
    });
  }

  document.querySelectorAll('[data-bs-toolbar-toggle]').forEach(function (btn) {
    var page = btn.closest('[data-bs-page]');
    if (!page) return;
    btn.addEventListener('click', function () {
      var open = page.classList.toggle('is-toolbar-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  (function initCollectionFilters() {
    if (!document.querySelector('[data-collection-root]')) return;

    var loading = false;
    var keepDrawer = false;
    var facetState = { category: [], material: [], color: [] };

    var MATERIAL_DEFS = [
      { id: 'lapis-lazuli', label: 'Lapis Lazuli', pattern: /lapis(\s+lazuli)?/i },
      { id: 'black-rutilated-quartz', label: 'Black Rutilated Quartz', pattern: /rutilated(\s+quartz)?/i },
      { id: 'rose-quartz', label: 'Rose Quartz', pattern: /rose\s+quartz/i },
      { id: 'blue-topaz', label: 'Blue Topaz', pattern: /blue\s+topaz|\btopaz\b/i },
      { id: 'baroque-pearl', label: 'Baroque Pearl', pattern: /baroque\s+pearl/i },
      { id: 'freshwater-pearl', label: 'Freshwater Pearl', pattern: /freshwater\s+pearl/i },
      { id: 'pearl', label: 'Pearl', pattern: /\bpearls?\b/i },
      { id: 'fluorite', label: 'Fluorite', pattern: /fluorite/i },
      { id: 'aquamarine', label: 'Aquamarine', pattern: /aquamarine/i },
      { id: 'sodalite', label: 'Sodalite', pattern: /sodalite/i },
      { id: 'amethyst', label: 'Amethyst', pattern: /amethyst/i },
      { id: 'blue-stone', label: 'Blue Stone', pattern: /blue\s+stone/i }
    ];

    var COLOR_DEFS = [
      { id: 'blue', label: 'Blue', pattern: /lapis|aquamarine|sodalite|blue\s+topaz|blue\s+stone|\bblue\b/i },
      { id: 'white', label: 'White', pattern: /\bpearls?\b|baroque\s+pearl|freshwater/i },
      { id: 'purple', label: 'Purple', pattern: /amethyst|\bviolet\b|\bpurple\b/i },
      { id: 'pink', label: 'Pink', pattern: /rose\s+quartz|\bpink\b/i },
      { id: 'green', label: 'Green', pattern: /fluorite|\bverdant\b|\bgreen\b/i },
      { id: 'black', label: 'Black', pattern: /rutilated|\bblack\b/i }
    ];

    function handleize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function matchDefs(title, defs) {
      var text = String(title || '');
      return defs.filter(function (def) {
        return def.pattern.test(text);
      });
    }

    function cardCategories(card) {
      var ids = [];
      function add(value) {
        var key = handleize(value);
        if (!key || ids.indexOf(key) !== -1) return;
        ids.push(key);
        if (key.charAt(key.length - 1) === 's') {
          var singular = key.slice(0, -1);
          if (singular && ids.indexOf(singular) === -1) ids.push(singular);
        } else if (ids.indexOf(key + 's') === -1) {
          ids.push(key + 's');
        }
      }
      add(card.getAttribute('data-type'));
      String(card.getAttribute('data-cats') || '').split(/\s+/).forEach(add);
      return ids;
    }

    function parseFacetPairs(raw) {
      if (!raw) return [];
      return String(raw)
        .split(',')
        .map(function (part) {
          part = part.trim();
          if (!part) return null;
          var splitAt = part.indexOf(':');
          if (splitAt === -1) {
            return { id: handleize(part), label: part };
          }
          return {
            id: part.slice(0, splitAt).trim(),
            label: part.slice(splitAt + 1).trim()
          };
        })
        .filter(Boolean);
    }

    function describeCard(card) {
      if (card._facetMeta) return card._facetMeta;
      var title = card.getAttribute('data-title') || '';
      var materials = parseFacetPairs(card.getAttribute('data-materials'));
      var colors = parseFacetPairs(card.getAttribute('data-colors'));
      if (!materials.length) materials = matchDefs(title, MATERIAL_DEFS);
      if (!colors.length) colors = matchDefs(title, COLOR_DEFS);
      card._facetMeta = {
        categories: cardCategories(card),
        materials: materials,
        colors: colors
      };
      return card._facetMeta;
    }

    function facetOptionHtml(facet, id, label) {
      return (
        '<li><a href="#" class="collection-filter__option" data-collection-filter-link data-collection-facet="' +
        facet +
        '" data-collection-value="' +
        id +
        '" aria-pressed="false">' +
        '<span class="collection-filter__box" aria-hidden="true"></span>' +
        '<span class="collection-filter__label">' +
        label +
        '</span></a></li>'
      );
    }

    function fillFacetHosts(root, facet, map) {
      var ids = Object.keys(map).sort(function (a, b) {
        return map[a].localeCompare(map[b]);
      });
      root.querySelectorAll('[data-facet-options="' + facet + '"]').forEach(function (host) {
        var existing = {};
        host.querySelectorAll('[data-collection-facet="' + facet + '"]').forEach(function (el) {
          existing[el.getAttribute('data-collection-value')] = true;
        });
        if (!ids.length) return;
        var list = host.querySelector('.collection-filter__list');
        if (!list) {
          host.innerHTML = '<ul class="collection-filter__list" role="list"></ul>';
          list = host.querySelector('.collection-filter__list');
        }
        ids.forEach(function (id) {
          if (existing[id]) return;
          list.insertAdjacentHTML('beforeend', facetOptionHtml(facet, id, map[id]));
        });
      });
    }

    function hydrateFacetOptions(root) {
      if (!root) return;
      var materials = {};
      var colors = {};
      root.querySelectorAll('[data-collection-grid] .product-card').forEach(function (card) {
        var meta = describeCard(card);
        meta.materials.forEach(function (item) {
          materials[item.id] = item.label;
        });
        meta.colors.forEach(function (item) {
          colors[item.id] = item.label;
        });
      });
      fillFacetHosts(root, 'material', materials);
      fillFacetHosts(root, 'color', colors);
    }

    function valuesMatch(selected, cardValues) {
      if (!selected.length) return true;
      return selected.some(function (value) {
        return cardValues.indexOf(value) !== -1;
      });
    }

    function clientFilterCount() {
      return facetState.category.length + facetState.material.length + facetState.color.length;
    }

    function setFilterButtonCount(root, count) {
      var btn = root.querySelector('[data-collection-drawer-open]');
      if (!btn) return;
      btn.classList.toggle('is-active', count > 0);
      var label = count > 0 ? 'FILTER (' + count + ')' : 'FILTER';
      var node = null;
      btn.childNodes.forEach(function (child) {
        if (child.nodeType === 3 && /FILTER/i.test(child.textContent)) node = child;
      });
      if (node) node.textContent = ' ' + label;
    }

    function syncOptionState(root) {
      root.querySelectorAll('[data-collection-facet]').forEach(function (option) {
        var facet = option.getAttribute('data-collection-facet');
        var value = option.getAttribute('data-collection-value');
        var active = !!(facetState[facet] && facetState[facet].indexOf(value) !== -1);
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function syncToolbarLabels(root) {
      ['category', 'material', 'color'].forEach(function (facet) {
        var drop = root.querySelector('[data-collection-dropdown][data-facet="' + facet + '"]');
        if (!drop) return;
        var btn = drop.querySelector('.collection-toolbar__filter');
        if (!btn) return;
        var selected = facetState[facet];
        var label = facet.toUpperCase();
        if (selected.length === 1) {
          var opt = root.querySelector(
            '[data-collection-facet="' + facet + '"][data-collection-value="' + selected[0] + '"] .collection-filter__label'
          );
          label = opt ? opt.textContent.trim().toUpperCase() : selected[0].replace(/-/g, ' ').toUpperCase();
        } else if (selected.length > 1) {
          label = facet.toUpperCase() + ' (' + selected.length + ')';
        }
        btn.classList.toggle('is-active', selected.length > 0);
        btn.textContent = label + ' ▾';
      });
      setFilterButtonCount(root, clientFilterCount());
    }

    function applyFacets(root) {
      if (!root) return;
      var cards = root.querySelectorAll('[data-collection-grid] .product-card');
      var visible = 0;
      cards.forEach(function (card) {
        var meta = describeCard(card);
        var show =
          valuesMatch(facetState.category, meta.categories) &&
          valuesMatch(
            facetState.material,
            meta.materials.map(function (item) {
              return item.id;
            })
          ) &&
          valuesMatch(
            facetState.color,
            meta.colors.map(function (item) {
              return item.id;
            })
          );
        card.classList.toggle('is-facet-hidden', !show);
        if (show) visible += 1;
      });
      var countEl = root.querySelector('[data-collection-count]');
      if (countEl) {
        var usesProducts = /product/i.test(countEl.textContent || '');
        if (usesProducts) {
          countEl.textContent = visible === 1 ? '1 product' : visible + ' products';
        } else {
          countEl.textContent = visible + ' ITEMS';
        }
      }
      var empty = root.querySelector('[data-collection-empty]');
      if (empty) empty.hidden = visible > 0;
      syncOptionState(root);
      syncToolbarLabels(root);
    }

    function toggleFacet(facet, value) {
      if (!facetState[facet] || !value) return;
      var list = facetState[facet];
      var index = list.indexOf(value);
      if (index === -1) list.push(value);
      else list.splice(index, 1);
    }

    function resetFacets() {
      facetState = { category: [], material: [], color: [] };
    }

    function refreshFacets(root) {
      hydrateFacetOptions(root);
      applyFacets(root);
    }

    function sectionUrl(url, sectionId) {
      var next = new URL(url, window.location.origin);
      next.searchParams.set('section_id', sectionId);
      return next.pathname + next.search;
    }

    function cleanUrl(url) {
      var next = new URL(url, window.location.origin);
      next.searchParams.delete('section_id');
      return next.pathname + next.search + next.hash;
    }

    function closeDropdowns(root) {
      (root || document).querySelectorAll('[data-collection-dropdown]').forEach(function (drop) {
        drop.classList.remove('is-open');
        var btn = drop.querySelector('.collection-toolbar__filter');
        var panel = drop.querySelector('.collection-toolbar__panel');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    function drawerEl(root) {
      return root ? root.querySelector('[data-collection-drawer]') : document.querySelector('[data-collection-drawer]');
    }

    function openDrawer(root) {
      var drawer = drawerEl(root);
      var btn = root && root.querySelector('[data-collection-drawer-open]');
      if (!drawer) return;
      drawer.hidden = false;
      document.body.classList.add('collection-filter-drawer-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer(root) {
      var drawer = drawerEl(root);
      var btn = root && root.querySelector('[data-collection-drawer-open]');
      if (!drawer) return;
      drawer.hidden = true;
      document.body.classList.remove('collection-filter-drawer-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    function activeRoot() {
      return document.querySelector('[data-collection-root]');
    }

    function loadCollection(url, options) {
      options = options || {};
      var root = activeRoot();
      if (!root || loading) return;
      var target;
      try {
        target = new URL(url, window.location.origin);
      } catch (err) {
        window.location.assign(url);
        return;
      }
      if (target.origin !== window.location.origin) {
        window.location.assign(url);
        return;
      }
      if (target.pathname !== window.location.pathname) {
        window.location.assign(cleanUrl(target.href));
        return;
      }
      var sectionId = root.getAttribute('data-section-id');
      if (!sectionId) {
        window.location.assign(cleanUrl(target.href));
        return;
      }

      loading = true;
      root.classList.add('is-loading');
      keepDrawer = !!options.keepDrawer;

      fetch(sectionUrl(url, sectionId), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = doc.querySelector('[data-collection-root][data-section-id="' + sectionId + '"]')
            || doc.querySelector('[data-collection-root]');
          if (!nextRoot) throw new Error('missing section');

          if (options.append) {
            var currentGrid = root.querySelector('[data-collection-grid]');
            var nextGrid = nextRoot.querySelector('[data-collection-grid]');
            var currentPager = root.querySelector('[data-collection-pagination]');
            var nextPager = nextRoot.querySelector('[data-collection-pagination]');
            if (currentGrid && nextGrid) {
              var cards = Array.prototype.slice.call(nextGrid.children);
              cards.forEach(function (card) {
                currentGrid.appendChild(card);
              });
            }
            if (currentPager && nextPager) currentPager.innerHTML = nextPager.innerHTML;
            root.classList.remove('is-loading');
          } else {
            nextRoot.classList.remove('is-loading');
            root.replaceWith(nextRoot);
            root = nextRoot;
            if (keepDrawer) openDrawer(root);
          }

          if (options.push && history.pushState) {
            history.pushState({ collectionUrl: true }, '', cleanUrl(url));
          } else if (options.replace && history.replaceState) {
            history.replaceState({ collectionUrl: true }, '', cleanUrl(url));
          }

          refreshFacets(activeRoot());
        })
        .catch(function () {
          window.location.assign(cleanUrl(url));
        })
        .finally(function () {
          loading = false;
          var current = activeRoot();
          if (current) current.classList.remove('is-loading');
        });
    }

    function applySort(value, push) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      loadCollection(url.pathname + url.search, { push: push !== false, keepDrawer: keepDrawer || !!drawerOpen() });
    }

    function drawerOpen() {
      var drawer = drawerEl(activeRoot());
      return !!(drawer && !drawer.hidden);
    }

    document.addEventListener('click', function (e) {
      var root = e.target.closest('[data-collection-root]') || activeRoot();
      if (!root) return;

      var dropBtn = e.target.closest('[data-collection-dropdown] > .collection-toolbar__filter');
      if (dropBtn) {
        e.preventDefault();
        e.stopPropagation();
        var drop = dropBtn.closest('[data-collection-dropdown]');
        var wasOpen = drop.classList.contains('is-open');
        closeDropdowns(root);
        if (!wasOpen) {
          drop.classList.add('is-open');
          dropBtn.setAttribute('aria-expanded', 'true');
          var panel = drop.querySelector('.collection-toolbar__panel');
          if (panel) panel.hidden = false;
        }
        return;
      }

      if (!e.target.closest('[data-collection-dropdown]')) closeDropdowns(root);

      if (e.target.closest('[data-collection-drawer-open]')) {
        e.preventDefault();
        openDrawer(root);
        return;
      }

      if (e.target.closest('[data-collection-drawer-close]')) {
        e.preventDefault();
        closeDrawer(root);
        return;
      }

      var sortOption = e.target.closest('[data-collection-sort-option]');
      if (sortOption) {
        e.preventDefault();
        keepDrawer = drawerOpen();
        applySort(sortOption.getAttribute('data-sort-value'), true);
        return;
      }

      var more = e.target.closest('[data-collection-load-more]');
      if (more) {
        e.preventDefault();
        loadCollection(more.href, { append: true, replace: true });
        return;
      }

      var link = e.target.closest('[data-collection-filter-link]');
      if (link) {
        e.preventDefault();
        var fromDrawer = !!e.target.closest('[data-collection-drawer]');
        if (link.classList.contains('collection-filter-drawer__clear')) {
          resetFacets();
          applyFacets(root);
        }
        var facet = link.getAttribute('data-collection-facet');
        var value = link.getAttribute('data-collection-value');
        if (facet && value && facetState.hasOwnProperty(facet)) {
          toggleFacet(facet, value);
          applyFacets(root);
          if (!fromDrawer) closeDropdowns(root);
          return;
        }
        loadCollection(link.href, { push: true, keepDrawer: fromDrawer });
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-collection-price-form]');
      if (!form) return;
      e.preventDefault();
      var url = new URL(window.location.href);
      var gteInput = form.querySelector('[data-price-gte]');
      var lteInput = form.querySelector('[data-price-lte]');
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('page');
      if (gteInput && gteInput.value !== '') {
        url.searchParams.set('filter.v.price.gte', String(Math.round(parseFloat(gteInput.value) * 100)));
      }
      if (lteInput && lteInput.value !== '') {
        url.searchParams.set('filter.v.price.lte', String(Math.round(parseFloat(lteInput.value) * 100)));
      }
      loadCollection(url.pathname + url.search, { push: true, keepDrawer: drawerOpen() });
    });

    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-collection-sort]');
      if (!select) return;
      applySort(select.value, true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var root = activeRoot();
      if (!root) return;
      closeDropdowns(root);
      if (drawerOpen()) closeDrawer(root);
    });

    if (history.replaceState) {
      history.replaceState({ collectionUrl: true }, '', window.location.href);
    }

    window.addEventListener('popstate', function () {
      if (!activeRoot()) return;
      loadCollection(window.location.href, { push: false, keepDrawer: false });
    });

    refreshFacets(activeRoot());
  })();

  syncResponsiveAccordions();
  window.addEventListener('resize', syncResponsiveAccordions);

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    var index = 0;
    var touchStartX = 0;
    var touchActive = false;

    function visibleCount() {
      if (window.innerWidth <= 749) return 2;
      if (window.innerWidth <= 990) return 3;
      if (window.innerWidth <= 1200) return 4;
      return 6;
    }

    function maxIndex() {
      return Math.max(0, track.children.length - visibleCount());
    }

    function stepWidth() {
      var items = track.children;
      if (!items.length) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    function setNavState() {
      var overflow = track.children.length > visibleCount();
      var atStart = index <= 0;
      var atEnd = index >= maxIndex();
      prev.disabled = !overflow || atStart;
      next.disabled = !overflow || atEnd;
      prev.classList.toggle('is-disabled', prev.disabled);
      next.classList.toggle('is-disabled', next.disabled);
      prev.setAttribute('aria-hidden', (!overflow || atStart) ? 'true' : 'false');
      next.setAttribute('aria-hidden', (!overflow || atEnd) ? 'true' : 'false');
    }

    function update() {
      if (!track.children.length) return;
      index = Math.min(index, maxIndex());
      track.style.transform = 'translateX(-' + (index * stepWidth()) + 'px)';
      setNavState();
    }

    prev.addEventListener('click', function () {
      if (index <= 0) return;
      index -= 1;
      update();
    });

    next.addEventListener('click', function () {
      if (index >= maxIndex()) return;
      index += 1;
      update();
    });

    track.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchActive = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!touchActive || !e.changedTouches.length) return;
      touchActive = false;
      var delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) < 40) return;
      if (delta > 0 && index < maxIndex()) index += 1;
      else if (delta < 0 && index > 0) index -= 1;
      update();
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  });

  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-slide]');
    var dots = slider.querySelectorAll('[data-dot]');
    if (!slides.length || !dots.length) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var n = i % slides.length;
        slides.forEach(function (s, j) { s.hidden = j !== n; });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      });
    });
  });

  document.querySelectorAll('[data-search-overlay]').forEach(function (overlay) {
    var input = overlay.querySelector('[data-search-input]');
    function openSearch(e) {
      if (e) e.preventDefault();
      overlay.hidden = false;
      document.body.classList.add('search-open');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
    function closeSearch() {
      overlay.hidden = true;
      document.body.classList.remove('search-open');
    }
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    overlay.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeSearch();
    });
  });

  document.querySelectorAll('[data-cart]').forEach(function (cart) {
    var form = cart.querySelector('.luneorae-cart__form');
    function changeLine(key, quantity) {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        window.location.reload();
      }).catch(function () {
        if (form) form.submit();
      });
    }
    cart.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var input = row.querySelector('[data-qty-input]');
      row.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10));
          input.value = next;
          changeLine(key, next);
        });
      });
      if (input) {
        input.addEventListener('change', function () {
          changeLine(key, Math.max(0, parseInt(input.value, 10) || 0));
        });
      }
      var remove = row.querySelector('[data-remove]');
      if (remove) {
        remove.addEventListener('click', function (e) {
          e.preventDefault();
          changeLine(key, 0);
        });
      }
    });
  });

  document.querySelectorAll('[data-product-page]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    var variantInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var optionInputs = root.querySelectorAll('[data-option-input]');
    var variants = [];
    var jsonEl = root.querySelector('[data-variants-json]');
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
    }

    function showMedia(id) {
      var thumb = root.querySelector('.product-page__thumb[data-media-id="' + id + '"]') || root.querySelector('.product-page__thumb');
      if (!thumb) return;
      var main = root.querySelector('.product-page__stage .product-page__image');
      var src = thumb.getAttribute('data-image');
      if (main && src) {
        main.src = src;
        if (main.hasAttribute('srcset')) main.removeAttribute('srcset');
      }
      root.querySelectorAll('.product-page__thumb').forEach(function (btn) {
        var on = btn === thumb;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    root.querySelectorAll('.product-page__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showMedia(btn.getAttribute('data-media-id'));
      });
    });

    root.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = root.querySelector('[data-qty-input]');
        if (!input) return;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-change'), 10));
        input.value = next;
      });
    });

    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        values.push(checked ? checked.value : '');
      });
      return values;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === options[i]; });
      });
    }

    function updateOptionLabels() {
      root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        var label = fieldset.querySelector('[data-option-value]');
        if (checked && label) label.textContent = checked.value;
        fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
          var wrap = input.closest('label');
          if (wrap) wrap.classList.toggle('is-active', input.checked);
        });
      });
    }

    function updateVariant() {
      var variant = findVariant(selectedOptions()) || variants[0];
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      updateOptionLabels();

      if (priceEl) {
        var current = priceEl.querySelector('[data-current-price]');
        var compare = priceEl.querySelector('[data-compare-price]');
        if (current) current.textContent = variant.price_formatted;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (!compare) {
            compare = document.createElement('s');
            compare.setAttribute('data-compare-price', '');
            priceEl.insertBefore(compare, current);
          }
          compare.textContent = variant.compare_formatted;
          compare.hidden = false;
        } else if (compare) {
          compare.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) {
          addText.textContent = variant.available
            ? addBtn.getAttribute('data-add-label')
            : addBtn.getAttribute('data-sold-out-label');
        }
      }
      var buyNowBtn = root.querySelector('[data-buy-now]');
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      var shareInput = root.querySelector('[data-share-input]');
      if (shareInput) shareInput.value = window.location.href;

      if (variant.featured_media_id) showMedia(variant.featured_media_id);
    }

    if (form) {
      form.addEventListener('submit', function () {
        optionInputs.forEach(function (input) { input.disabled = true; });
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    var buyNow = root.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (!variantInput) return;
        var qtyInput = root.querySelector('[data-qty-input]');
        var payload = {
          id: Number(variantInput.value),
          quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)
        };
        buyNow.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
        }).catch(function () {
          buyNow.disabled = false;
          if (form) form.submit();
        });
      });
    }

    var share = root.querySelector('[data-share]');
    if (share) {
      var panel = share.querySelector('[data-share-panel]');
      var toggle = share.querySelector('[data-share-toggle]');
      var copyBtn = share.querySelector('[data-share-copy]');
      var shareInput = share.querySelector('[data-share-input]');
      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          panel.hidden = !panel.hidden;
        });
      }
      if (copyBtn && shareInput) {
        copyBtn.addEventListener('click', function () {
          shareInput.select();
          navigator.clipboard.writeText(shareInput.value).then(function () {
            var prev = copyBtn.textContent;
            copyBtn.textContent = 'copied';
            setTimeout(function () { copyBtn.textContent = prev; }, 1600);
          }).catch(function () {
            document.execCommand('copy');
          });
        });
      }
    }
  });

  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var id = Number(btn.getAttribute('data-variant-id'));
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add failed');
      btn.textContent = 'Added';
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 1600);
    }).catch(function () {
      btn.disabled = false;
      window.location.href = btn.closest('.product-card') && btn.closest('.product-card').querySelector('a')
        ? btn.closest('.product-card').querySelector('a').href
        : cartRoot + 'cart';
    });
  });

  (function initCookieBanner() {
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    var prefs = banner.querySelector('[data-cookie-prefs]');
    var manageBtn = banner.querySelector('[data-cookie-manage]');
    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var saveBtn = banner.querySelector('[data-cookie-save]');
    var storageKey = 'luneorae-cookie-consent';

    function hideShopifyBanner() {
      document.querySelectorAll('[id^="shopify-pc"], shopify-cookie-banner, .shopify-pc__banner').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }

    function readStored() {
      try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (e) { return null; }
    }

    function hasAnswered(consent) {
      if (!consent) return false;
      return ['analytics', 'marketing', 'preferences'].some(function (key) {
        return consent[key] === 'yes' || consent[key] === 'no' || consent[key] === true || consent[key] === false;
      });
    }

    function hideBanner() {
      banner.hidden = true;
      document.body.classList.remove('luneorae-cookie-visible');
    }

    function showBanner() {
      banner.hidden = false;
      document.body.classList.add('luneorae-cookie-visible');
    }

    function payloadFromToggles(all) {
      if (all) {
        return { analytics: true, marketing: true, preferences: true, sale_of_data: true };
      }
      var data = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      banner.querySelectorAll('[data-cookie-key]').forEach(function (input) {
        data[input.getAttribute('data-cookie-key')] = input.checked;
      });
      return data;
    }

    function saveConsent(payload) {
      try { localStorage.setItem(storageKey, JSON.stringify(payload)); } catch (e) {}
      var api = window.Shopify && Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === 'function') {
        api.setTrackingConsent(payload, hideBanner);
      } else {
        hideBanner();
      }
    }

    function ready(fn) {
      if (window.Shopify && Shopify.customerPrivacy) { fn(Shopify.customerPrivacy); return; }
      if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          fn(window.Shopify && Shopify.customerPrivacy);
        });
        return;
      }
      fn(null);
    }

    hideShopifyBanner();
    var observer = new MutationObserver(hideShopifyBanner);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);

    if (readStored()) hideBanner();
    else showBanner();

    ready(function (api) {
      hideShopifyBanner();
      if (readStored()) { hideBanner(); return; }
      var current = api && typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : null;
      if (hasAnswered(current)) { hideBanner(); return; }
      showBanner();
    });

    if (manageBtn) {
      var manageLabel = manageBtn.textContent.trim();
      manageBtn.addEventListener('click', function () {
        var open = prefs && !prefs.hidden;
        if (prefs) prefs.hidden = open;
        if (saveBtn) saveBtn.hidden = open;
        if (acceptBtn) acceptBtn.hidden = !open;
        manageBtn.textContent = open ? manageLabel : 'Close';
      });
    }
    if (acceptBtn) acceptBtn.addEventListener('click', function () { saveConsent(payloadFromToggles(true)); });
    if (saveBtn) saveBtn.addEventListener('click', function () { saveConsent(payloadFromToggles(false)); });
  })();

  (function initPromoPopup() {
    var popup = document.querySelector('[data-promo-popup]');
    if (!popup) return;

    var storageKey = 'luneorae-promo-popup';
    var delayMin = 3000;
    var delayMax = 5000;
    var form = popup.querySelector('.luneorae-promo__form');
    var success = popup.querySelector('[data-promo-success]');
    var legal = popup.querySelector('.luneorae-promo__legal');
    var showTimer = null;

    function hasSeen() {
      try { return localStorage.getItem(storageKey) === '1'; } catch (e) { return true; }
    }

    function markSeen() {
      try { localStorage.setItem(storageKey, '1'); } catch (e) {}
    }

    function cookieVisible() {
      var banner = document.querySelector('[data-cookie-banner]');
      return !!(banner && !banner.hidden && document.body.classList.contains('luneorae-cookie-visible'));
    }

    function shippingVisible() {
      var notice = document.querySelector('[data-shipping-notice]');
      return !!(notice && !notice.hidden);
    }

    function overlayBlocking() {
      return cookieVisible() || shippingVisible();
    }

    function flattenLegalLinks() {
      if (!legal) return;
      legal.querySelectorAll('a').forEach(function (link) {
        var text = document.createTextNode(link.textContent);
        link.parentNode.replaceChild(text, link);
      });
    }

    function openPopup() {
      if (hasSeen() || !popup.hidden) return;
      flattenLegalLinks();
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('luneorae-promo-open');
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('luneorae-promo-open');
    }

    function scheduleOpen(afterMs) {
      if (showTimer) clearTimeout(showTimer);
      showTimer = setTimeout(function () {
        if (hasSeen()) return;
        if (overlayBlocking()) {
          waitForCookieDismiss();
          return;
        }
        openPopup();
      }, afterMs);
    }

    function waitForCookieDismiss() {
      var observer = new MutationObserver(function () {
        if (hasSeen()) {
          observer.disconnect();
          return;
        }
        if (!overlayBlocking()) {
          observer.disconnect();
          scheduleOpen(delayMin);
        }
      });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      var banner = document.querySelector('[data-cookie-banner]');
      if (banner) {
        observer.observe(banner, { attributes: true, attributeFilter: ['hidden'] });
      }
      var shipping = document.querySelector('[data-shipping-notice]');
      if (shipping) {
        observer.observe(shipping, { attributes: true, attributeFilter: ['hidden'] });
      }
    }

    function randomDelay() {
      return delayMin + Math.floor(Math.random() * (delayMax - delayMin + 1));
    }

    flattenLegalLinks();
    if (legal) {
      new MutationObserver(flattenLegalLinks).observe(legal, { childList: true, subtree: true });
    }

    if (hasSeen()) return;

    scheduleOpen(randomDelay());

    popup.querySelectorAll('[data-promo-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        markSeen();
        closePopup();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) {
        markSeen();
        closePopup();
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (hasSeen()) return;

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch(form.action || '/contact', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin'
        }).then(function () {
          markSeen();
          popup.classList.add('is-success');
          if (success) success.hidden = false;
          if (submitBtn) submitBtn.disabled = false;
          setTimeout(closePopup, 2800);
        }).catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          markSeen();
          form.submit();
        });
      });
    }
  })();

  (function initShippingNotice() {
    var popup = document.querySelector('[data-shipping-notice]');
    if (!popup) return;

    var storageKey = 'luneorae-shipping-notice';
    var delayMin = 1200;
    var delayMax = 2200;
    var showTimer = null;

    function hasSeen() {
      try { return localStorage.getItem(storageKey) === '1'; } catch (e) { return true; }
    }

    function markSeen() {
      try { localStorage.setItem(storageKey, '1'); } catch (e) {}
    }

    function cookieVisible() {
      var banner = document.querySelector('[data-cookie-banner]');
      return !!(banner && !banner.hidden && document.body.classList.contains('luneorae-cookie-visible'));
    }

    function openPopup() {
      if (hasSeen() || !popup.hidden) return;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('luneorae-ship-open');
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('luneorae-ship-open');
    }

    function scheduleOpen(afterMs) {
      if (showTimer) clearTimeout(showTimer);
      showTimer = setTimeout(function () {
        if (hasSeen()) return;
        if (cookieVisible()) {
          waitForCookieDismiss();
          return;
        }
        openPopup();
      }, afterMs);
    }

    function waitForCookieDismiss() {
      var observer = new MutationObserver(function () {
        if (hasSeen()) {
          observer.disconnect();
          return;
        }
        if (!cookieVisible()) {
          observer.disconnect();
          scheduleOpen(delayMin);
        }
      });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      var banner = document.querySelector('[data-cookie-banner]');
      if (banner) {
        observer.observe(banner, { attributes: true, attributeFilter: ['hidden'] });
      }
    }

    function randomDelay() {
      return delayMin + Math.floor(Math.random() * (delayMax - delayMin + 1));
    }

    if (hasSeen()) return;

    scheduleOpen(randomDelay());

    popup.querySelectorAll('[data-shipping-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        markSeen();
        closePopup();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) {
        markSeen();
        closePopup();
      }
    });
  })();

  (function initBlogCategoryNav() {
    var nav = document.querySelector('[data-blog-categories]');
    var content = document.getElementById('blog-content');
    if (!nav || !content) return;

    var loading = false;

    function loadBlog(url, push) {
      if (loading) return;
      loading = true;
      content.classList.add('is-loading');

      fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextContent = doc.getElementById('blog-content');
          var nextNav = doc.querySelector('.blog-categories__list');
          if (nextContent) content.innerHTML = nextContent.innerHTML;
          if (nextNav) {
            var list = nav.querySelector('.blog-categories__list');
            if (list) list.innerHTML = nextNav.innerHTML;
          }
          if (push && history.pushState) {
            history.pushState({ blogUrl: url }, '', url);
          }
        })
        .catch(function () {
          window.location.assign(url);
        })
        .finally(function () {
          loading = false;
          content.classList.remove('is-loading');
        });
    }

    nav.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || !nav.contains(link)) return;
      if (link.target === '_blank') return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;

      var nextUrl;
      try {
        nextUrl = new URL(link.href, window.location.origin).href;
      } catch (err) {
        return;
      }

      if (nextUrl.split('#')[0] === window.location.href.split('#')[0]) {
        e.preventDefault();
        nav.querySelectorAll('a').forEach(function (a) { a.classList.remove('is-active'); });
        link.classList.add('is-active');
        return;
      }

      e.preventDefault();
      loadBlog(nextUrl, true);
    });

    if (history.replaceState) {
      history.replaceState({ blogUrl: window.location.href }, '', window.location.href);
    }

    window.addEventListener('popstate', function () {
      loadBlog(window.location.href, false);
    });
  })();
});
